export function safelyParseJSON( json ) {
	let parsed

	try {
		parsed = JSON.parse(json)
	} catch ( e ) {

	}

	return parsed
}
